import api from '~/services/api';
import PropTypes from 'prop-types';
import errorHandler from '~/Utils/errorHandler';
import { message } from 'antd';
import i18next from 'i18next';

const endPoint = 'projects';

// FIND ALL PROJECT TYPES
export const findAllProjectTypes = async () => {
  try {
    const { data } = await api.get(`/${endPoint}/findAllProjectTypes`);
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// PAGINATION
export const paginationProjects = async params => {
  try {
    const { data } = await api.post(`/${endPoint}/pagination`, params);
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// FIND ALL
export const findAllProjects = async (filters) => {
  try {
    const { data } = await api.post(`/${endPoint}/findAll`, filters);
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// FIND BY ID DATA
export const findByIdDataProject = async id => {
  try {
    const { data } = await api.get(`/${endPoint}/findByIdData`, {
      headers: { 'Content-Type': 'multipart/form-data' },
      params: { id },
    });
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// CREATE
export const createProject = async values => {
  try {
    const { data } = await api.post(`/${endPoint}/create`, values);
    message.success(i18next.t(`messages:${endPoint}.success`));
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// UPDATE
export const updateProject = async values => {
  try {
    const { data } = await api.put(`/${endPoint}/update`, values);
    message.success(i18next.t(`messages:${endPoint}.successEdit`));
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// DELETE
export const deleteProject = async id => {
  try {
    const { data } = await api.delete(`/${endPoint}/delete/${id}`);
    message.success(i18next.t(`messages:${endPoint}.successDelete`));
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

paginationProjects.propTypes = {
  params: PropTypes.object.isRequired,
};

findAllProjects.propTypes = {
  filters: PropTypes.object.isRequired,
};

findByIdDataProject.propTypes = {
  id: PropTypes.string.isRequired,
}

createProject.propTypes = {
  values: PropTypes.object.isRequired,
};

updateProject.propTypes = {
  values: PropTypes.object.isRequired,
};

deleteProject.propTypes = {
  id: PropTypes.string.isRequired,
};
